module.exports = __webpack_public_path__ + "static/img/timg.54dd087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/timg.png
// module id = 14Bg
// module chunks = 1